import { getMessages } from '../../../../../../../store/constants';

export const NOTIFY_SEARCH_PLACEHOLDER = getMessages().getText('common.select_users');
